<template>
  <div ref="container" class="otp-button otp-button-white">
    <div class="otp-p-l">
      <div class="otp-logo"></div>
      <strong>
        <a data-fancybox data-type="iframe" :href="creditUrl">
          <span class="otp-green">{{ $t('paymentOTPBtn') }}</span>
        </a>
      </strong>
    </div>
  </div>
</template>

<script>
import { Fancybox } from '@fancyapps/ui'

export default {
  name: 'OTPCredit',
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data: () => {
    return {}
  },
  computed: {
    creditUrl() {
      const price = this.product.newPrice
        ? this.product.newPrice
        : this.product.price
      const name =
        this.product[`name_${this.$i18n.locale}`] || this.product.name
      const name_m = 'apptown.com.ua'
      const email_m = 'AppTown.info@gmail.com'
      return `https://www.otpbank.com.ua/otpcredit/calculator/single/?price=${price}&name_t=${name}&name_m=${name_m}&email_m=${email_m}`
    },
  },
  beforeMount() {
    let css = document.createElement('link')
    css.href =
      'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css'
    css.type = 'text/css'
    css.rel = 'stylesheet'
    document.head.appendChild(css)
  },
  mounted() {
    Fancybox.bind(this.$refs.container, '[data-fancybox]', {})
  },
  updated() {
    Fancybox.unbind(this.$refs.container)
    Fancybox.close()

    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    })
  },
  unmounted() {
    Fancybox.destroy()
  },
}
</script>

<style>
:root {
  --fancybox-zIndex: 10000;
}
.otp-button {
  font: 13px/20px 'Tahoma', Arial, sans-serif;
  position: relative;
  display: inline-block;
  margin: 12px;
  vertical-align: top;
  height: 36px;
  line-height: 35px;
  padding: 0 10px;
  font-size: 14px;
  color: white;
  text-align: center;
  text-decoration: none;
  text-shadow: 0 -1px rgba(0, 0, 0, 0.4);
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 3px;
  cursor: pointer;
  -moz-box-shadow: inset 0 1px rgba(255, 255, 255, 0.1),
    inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 1px 2px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: inset 0 1px rgba(255, 255, 255, 0.1),
    inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 1px 2px rgba(0, 0, 0, 0.25);
  box-shadow: inset 0 1px rgba(255, 255, 255, 0.1),
    inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 1px 2px rgba(0, 0, 0, 0.25);
}
.otp-button a {
  color: white;
  text-decoration: none;
}
.otp-button strong {
  font-weight: bold;
}
.otp-button .otp-green {
  color: #006a2c;
  text-decoration: none;
}
.otp-button .otp-p-l {
  padding-left: 36px;
}

.otp-button:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  background-image: -webkit-radial-gradient(
    center top,
    farthest-corner,
    rgba(255, 255, 255, 0.08),
    rgba(255, 255, 255, 0)
  );
  background-image: -moz-radial-gradient(
    center top,
    farthest-corner,
    rgba(255, 255, 255, 0.08),
    rgba(255, 255, 255, 0)
  );
  background-image: -o-radial-gradient(
    center top,
    farthest-corner,
    rgba(255, 255, 255, 0.08),
    rgba(255, 255, 255, 0)
  );
  background-image: radial-gradient(
    center top,
    farthest-corner,
    rgba(255, 255, 255, 0.08),
    rgba(255, 255, 255, 0)
  );
}
.otp-button:hover:before {
  background-image: -webkit-radial-gradient(
    farthest-corner,
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0.03)
  );
  background-image: -moz-radial-gradient(
    farthest-corner,
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0.03)
  );
  background-image: -o-radial-gradient(
    farthest-corner,
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0.03)
  );
  background-image: radial-gradient(
    farthest-corner,
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0.03)
  );
}

.otp-button:active {
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}
.otp-button:active:before {
  content: none;
}
.otp-button-white {
  border-color: #d2d1d1;
  background: #dcdcdc;
  background-image: -webkit-linear-gradient(top, #ffffff 5%, #f6f6f6 100%);
  background-image: -moz-linear-gradient(top, #ffffff 5%, #f6f6f6 100%);
  background-image: -o-linear-gradient(top, #ffffff 5%, #f6f6f6 100%);
  background-image: linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
}
.otp-button-white:hover {
  background: -moz-linear-gradient(top, #f6f6f6 5%, #ffffff 100%);
  background: -webkit-linear-gradient(top, #f6f6f6 5%, #ffffff 100%);
  background: -o-linear-gradient(top, #f6f6f6 5%, #ffffff 100%);
  background: linear-gradient(to bottom, #f6f6f6 5%, #ffffff 100%);
  border-color: #c8c8c8;
}
.otp-button-white .otp-logo {
  border-right: 1px solid rgb(255, 255, 255);
  box-shadow: -1px 0px 0px 0px rgb(220, 220, 220) inset;
  height: 36px;
  top: 0px;
  left: 0px;
  display: block;
  width: 36px;
  position: absolute;
  background: url('https://www.otpbank.com.ua/otpcredit/calculator/source_files/calculator/img/otp-green.png')
    no-repeat scroll center center transparent;
}
</style>
